var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"p-0 h-100"},[_c(_vm.Parameter.Type + 'Item',{tag:"component",attrs:{"parameter":_vm.Parameter,"IsEditor":_vm.IsEditor},on:{"change-parameter":_vm.changeParameter,"child-event":_vm.listeners}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }